import React, { useCallback, useEffect, useMemo } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@material-ui/core';
import { useQueryContext } from '@sierralabs/query-ui';
import SiteTableRenderer from '../common/table/SiteTableRenderer';
import { useSiteContext } from '../SiteContext';
export const ChartItemsDialog = props => {
    var _a;
    const { open, title = 'All Items', tableComponent, filterExpressionMap, actions, onClose, onRowClick, setPagination } = props;
    const { isHover, hoverProps } = useSiteContext();
    const { queries, queryResults, isRunningQuery, runQueryOrPaginated } = useQueryContext();
    const tableClasses = ['site-table'];
    if (tableComponent && isHover(tableComponent)) {
        tableClasses.push('component-hover');
    }
    const queryId = (_a = tableComponent === null || tableComponent === void 0 ? void 0 : tableComponent.queryIds) === null || _a === void 0 ? void 0 : _a[0];
    const { columns = [], hidePagination = true } = (tableComponent === null || tableComponent === void 0 ? void 0 : tableComponent.props) || {};
    const queryResult = queryId
        ? queryResults.find(result => result.queryId === queryId)
        : undefined;
    const query = queryId
        ? queries.find(query => query.id === queryId)
        : undefined;
    /**
     * Useful to reset the previous pagination config in order to prevent
     * having offsset that out of range
     */
    const onDialogClose = () => {
        setPagination({ page: 0, limit: 100, order: '', direction: 'ASC' });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const expressionMap = useMemo(() => {
        const expressionMap = filterExpressionMap || { queryType: 'select' };
        return expressionMap;
    }, [filterExpressionMap]);
    const runQueryWithFilters = useCallback(() => {
        runQueryOrPaginated(queryId, !hidePagination, expressionMap);
    }, [expressionMap, hidePagination, queryId, runQueryOrPaginated]);
    useEffect(() => {
        if (open) {
            runQueryWithFilters();
        }
    }, [runQueryWithFilters, open]);
    return (React.createElement(Dialog, { open: open, onClose: onDialogClose, fullWidth: true, maxWidth: 'md' },
        isRunningQuery && React.createElement(LinearProgress, null),
        React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, { style: { padding: 0 } }, query && tableComponent && (React.createElement(SiteTableRenderer, { columns: columns, queryResult: queryResult, component: tableComponent, hidePagination: hidePagination, onRowClick: onRowClick, onPaginationChange: setPagination, renderHeader: columns => columns, tableProps: Object.assign(Object.assign({}, hoverProps(tableComponent)), { className: tableClasses.join(' ') }) }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onDialogClose }, "Close"),
            actions)));
};
//# sourceMappingURL=ChartItemsDialog.js.map